import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import { devices } from '../../../utils/screen_sizes'
import Hero from '../../components/Hero/Hero'
import MarkettingSection from '../../components/MarkettingSection/MarkettingSection'
import AboutSection from '../../components/AboutSection/AboutSection'
import StoresSection from '../../components/StoresSection/StoresSection'
import {
    carousel_images,
    carousel_images_mobile,
    carousel_path,
} from './staticData'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import PropTypes from 'prop-types'
import Cookies from 'universal-cookie'
import { Grid, CircularProgress, TextField } from '@material-ui/core'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import * as yup from 'yup'
import { API_KEY, API_SECRET, makeHttpRequest } from 'utils/api_utils'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}))
function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    )
}
BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
}
const validationSchema = yup.object({
    fname: yup
        .string('Enter your First Name')
        .required('First Name is required'),
    lname: yup.string('Enter your Last Name'),
    phone: yup
        .string('Enter your Phone Number')
        .required('Phone Number is required'),
})
const useStyles = makeStyles(({ palette, ...theme }) => ({
    changeButton: {
        background: '#42c8b7',
        color: '#fff',
        width: '100%',

        '&:hover': {
            backgroundColor: '#42c8b7',
            color: '#fff',
            opacity: 0.8,
        },
    },
}))
const HomePage = () => {

    const [country, setCountry] = useState('')
    const [matches, setMatches] = useState(
        window.matchMedia(devices.laptop).matches
    )
    const [open, setOpen] = React.useState(false)
    const formik = useFormik({
        initialValues: {
            lname: '',
            fname: '',
            phone: '',
            isupdateChecked: false,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIsPostingWarranty(true)
            cookies.set('submitBadiliLatestUpdate', 'Latestupdate', {
                path: '/',
            })
            let reqObj = {
                fname: values.fname,
                lname: values.lname,
                phone: values.phone,
                isupdateChecked: values.isupdateChecked,
                country: country,
            }

            fetch(`${process.env.REACT_APP_API_URL}popup_form`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Key: API_KEY,
                    Secret: API_SECRET,
                    country: localStorage.getItem('country') || 'ke',
                },
                body: JSON.stringify(reqObj),
            })
                .then((response) => response.json())
                .then(({ success, msg }) => {
                    if (success) {
                        setMessage({
                            ...message,
                            msg: msg,
                            severity: 'success',
                        })

                        setIsPostingWarranty(false)
                        formik.resetForm()
                    } else {
                        setMessage({ ...message, msg: msg, severity: 'error' })

                        setIsPostingWarranty(false)
                    }
                })
                .catch((error) => {
                    console.error('Error:', error)
                    setMessage({ ...message, msg: message, severity: 'error' })
                    setIsPostingWarranty(false)
                })
        },
    })
    const cookies = new Cookies()
    const [isPostingWarranty, setIsPostingWarranty] = useState(false)
    const [message, setMessage] = useState({
        msg: '',
        severity: '',
    })
    const classes = useStyles()

    // const handleInputChange = (event) => {
    //     let { value } = event.target
    //     search(value)
    // }

    // const search = useMemo(
    //     () =>
    //         debounce((query) => {
    //             let tempList = originalList.filter((item) =>
    //                 item.projectName.toLowerCase().match(query.toLowerCase())
    //             )
    //             setList([...tempList])
    //         }, 200),
    //     [originalList]
    // )

    // const fetchModels = async () => {
    //     const { success, deviceModels } = await makeHttpRequest(
    //         'get_device_model/6165c8683c6ca93814dc21ad',
    //         'GET'
    //     )

    //     if (success) setList(deviceModels)
    // }

    // useEffect(() => {
    //     fetchModels()
    // }, [])
    const handleClose = () => {
        setOpen(false)
        var date = new Date()
        date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
        cookies.set('cancelBadiliLatestUpdate', 'cancelLatestupdate', {
            path: '/',
            expires: date,
        })
    }

    // useEffect(() => {
    //     window
    //         .matchMedia('(min-width: 1200px)')
    //         .addEventListener('change', (e) => setMatches(e.matches))
    //     setTimeout(() => {
    //         setOpen(true)
    //     }, 10000)
    //     if (window.location.hostname === 'sell.badili.ke') {
    //         setCountry('ke')
    //         localStorage.setItem('country', 'ke')
    //     } else if (window.location.hostname === 'sell.badili.co.tz') {
    //         setCountry('tz')
    //         localStorage.setItem('country', 'tz')
    //     } else if (window.location.hostname === 'sell.badili.ug') {
    //         setCountry('ug')
    //         localStorage.setItem('country', 'ug')
    //     } else {
    //         setCountry('ke')
    //     }
    // }, [])
    useEffect(() => {
        // Add event listener for media query
        const mediaQuery = window.matchMedia('(min-width: 1200px)');
        const mediaQueryHandler = (e) => setMatches(e.matches);
        mediaQuery.addEventListener('change', mediaQueryHandler);
    
        // Set timeout to open something after 10 seconds
        const timeoutId = setTimeout(() => {
            setOpen(true);
        }, 10000);
    
        // Detect country based on hostname and set in state or localStorage
        const hostname = window.location.hostname;
        let country = 'ke'; // Default country
    
        if (hostname === 'sell.badili.ke') {
            country = 'ke';
        } else if (hostname === 'sell.badili.co.tz') {
            country = 'tz';
        } else if (hostname === 'sell.badili.ug') {
            country = 'ug';
        }
    
        setCountry(country);
        localStorage.setItem('country', country);
    
        // Clean up event listener and timeout
        return () => {
            mediaQuery.removeEventListener('change', mediaQueryHandler);
            clearTimeout(timeoutId);
        };
    }, []);
    return (
        <>
            <>
                <Hero
                    images={matches ? carousel_images : carousel_images_mobile}
                    file_path={carousel_path}
                />
                <AboutSection />

                <MarkettingSection />
                <StoresSection />
            </>
            {cookies.get('cancelBadiliLatestUpdate') ||
            cookies.get('submitBadiliLatestUpdate') ? (
                ''
            ) : (
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                    >
                        Want to get exclusive offers, deals and latest updates?{' '}
                        <br /> Drop in your details and be the first one to
                        know!
                    </BootstrapDialogTitle>
                    <form
                        noValidate
                        autoComplete="off"
                        className="warranty-form"
                        onSubmit={formik.handleSubmit}
                    >
                        <DialogContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        className="mb-4"
                                        label="First Name"
                                        name="fname"
                                        variant="standard"
                                        fullWidth
                                        value={formik.values.fname}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.fname &&
                                            Boolean(formik.errors.fname)
                                        }
                                        helperText={
                                            formik.touched.fname &&
                                            formik.errors.fname
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        className="mb-4"
                                        label="Last Name"
                                        variant="standard"
                                        fullWidth
                                        name="lname"
                                        value={formik.values.lname}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.lname &&
                                            Boolean(formik.errors.lname)
                                        }
                                        helperText={
                                            formik.touched.lname &&
                                            formik.errors.lname
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        className="mb-4"
                                        label="Phone Number"
                                        variant="standard"
                                        fullWidth
                                        name="phone"
                                        value={formik.values.phone}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.phone &&
                                            Boolean(formik.errors.phone)
                                        }
                                        helperText={
                                            formik.touched.phone &&
                                            formik.errors.phone
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                formik.values.isupdateChecked
                                            }
                                        />
                                    }
                                    label="Don't show me again"
                                    name="isupdateChecked"
                                    onChange={formik.handleChange}
                                />
                            </FormGroup>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                className="register-warranty-btn"
                                disabled={isPostingWarranty}
                                style={{ backgroundColor: '#58cab9' }}
                            >
                                {isPostingWarranty && (
                                    <>
                                        <CircularProgress
                                            size={17}
                                            className={`text-white mr-2 ${classes.buttonProgress}`}
                                        />
                                        Just a moment
                                    </>
                                )}
                                {!isPostingWarranty && 'Submit'}
                            </Button>
                        </DialogActions>
                    </form>
                </BootstrapDialog>
            )}
        </>
    )
}

export default HomePage
